import ScaledWrapper from '@components/ScaledWrapper/ScaledWrapper'
import { useConfigurationStore } from '@stores/configurationStore'
import { FC, useCallback, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { Loader } from '@components'
import { useTranslation } from '@amusnet/translations/react'

const PaytableConfirmation: FC = () => {
    const { t } = useTranslation()
    const setIsPaytableConfirmationAccepted = useConfigurationStore((state) => state.setIsPaytableConfirmationAccepted)
    const paytableUrl = useConfigurationStore((state) => state.paytableUrl)
    const paytableData = useConfigurationStore((state) => state.paytableData)
    const iframeRef = useRef<HTMLIFrameElement>(null)
    const [isLoaderActive, setIsLoaderActive] = useState(true)
    const [hasIframeLoaded, setHasIframeLoaded] = useState(false)
    const [isAccepted, setIsAccepted] = useState(false)

    const sendDataToIframe = useCallback(() => {
        const iframe = iframeRef.current

        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage({ type: 'paytableData', payload: paytableData }, '*')
        }
    }, [paytableData])

    const handleIframeLoad = () => {
        setIsLoaderActive(false)
        setHasIframeLoaded(true)
        sendDataToIframe()
    }

    const onAcceptClick = useCallback(() => {
        // Send message to engine straight away so it starts rendering
        setIsLoaderActive(true)
        setIsAccepted(true)

        const paytableConfirmationAcceptedMessage = { type: 'paytableConfirmationAccepted' }

        window.postMessage(paytableConfirmationAcceptedMessage)

        // Give time to engine to render its components
        setTimeout(() => {
            setIsPaytableConfirmationAccepted(true)
            setIsLoaderActive(false)
        }, 1000)
    }, [])

    return createPortal(
        <div className="fixed w-[100vw] h-[100vh] bg-black z-999999">
            {!isAccepted && (
                <ScaledWrapper>
                    <div className="flex flex-col w-full h-full pt-6">
                        <iframe
                            ref={iframeRef}
                            onLoad={handleIframeLoad}
                            src={paytableUrl}
                            className="w-full h-full border-none block"
                        />
                        {hasIframeLoaded && (
                            <div className="w-full py-8 flex justify-center items-center z-10 shadow-[0_-36px_32px_-32px_rgba(255,255,255,0.2)]">
                                <button
                                    className="bg-[green] text-white py-[0.75em] px-[1em] border-none rounded-[0.5em] text-[24px] font-inherit cursor-pointer flex-none appearance-none"
                                    onClick={onAcceptClick}
                                >
                                    {t('gameui.accept')}
                                </button>
                            </div>
                        )}
                    </div>
                </ScaledWrapper>
            )}
            {isLoaderActive && <Loader />}
        </div>,
        document.body
    )
}

export default PaytableConfirmation
